<span *ngIf="isShowButton('SIZE')" class="ql-formats">
  <select class="ql-size">
    <!-- default (normal) -->
    <option selected value="14px">14</option>
    <option value="16px">16</option>
    <option value="18px">18</option>
    <option value="20px">20</option>
    <option value="22px">22</option>
    <option value="24px">24</option>
    <option value="26px">26</option>
    <option value="28px">28</option>
  </select>
</span>
<span *ngIf="isShowButton('TEXT_DECORATION')" class="ql-formats">
  <button type="button" class="ql-bold" aria-label="Bold"></button>
  <button type="button" class="ql-italic" aria-label="Italic"></button>
  <button type="button" class="ql-underline" aria-label="Underline"></button>
</span>
<span *ngIf="isShowButton('INSERT')" class="ql-formats">
  <button type="button" class="ql-link" aria-label="Insert Link"></button>
  <button type="button" class="ql-image" aria-label="Insert Image"></button>
</span>
<span *ngIf="isShowButton('LIST')" class="ql-formats">
  <button
    value="ordered"
    type="button"
    class="ql-list"
    aria-label="Ordered List"
  ></button>
  <button
    value="bullet"
    aria-label="Unordered List"
    type="button"
    class="ql-list"
  ></button>
</span>
<span *ngIf="isShowButton('ALIGNMENT')" class="ql-formats">
  <button
    type="button"
    class="ql-align"
    value=""
    aria-label="Align Left"
  ></button>
  <button
    type="button"
    class="ql-align"
    value="center"
    aria-label="Align Center"
  ></button>
  <button
    type="button"
    class="ql-align"
    value="right"
    aria-label="Align Right"
  ></button>
  <button
    type="button"
    class="ql-align"
    value="justify"
    aria-label="Justify"
  ></button>
</span>
